import { twMerge } from "tailwind-merge";
import { Typography } from "@pondigitalsolutions/pon-component-library";
import { useTranslation } from "react-i18next";

interface LeadershipLabelProps {
  className?: string;
}

export const LeadershipLabel = ({ className }: LeadershipLabelProps) => {
  const {t} = useTranslation();

  return (
    <div
      className={twMerge(
        "absolute rounded-e-sm bg-accent_one-500 px-2.5 py-2 lg:px-4",
        className
      )}
    >
      <Typography
        size="xs"
        className="trim-both-cap-alphabetic text-secondary-950 lg:text-sm"
      >
        {t("StartPage.leadership")}
      </Typography>
    </div>
  );
};
